// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"cde87eed","102":"fd7f0c8c","388":"93ec107a","458":"31057261","607":"a5de769b","914":"5d630089"}[chunkId] + ".chunk.js";
};